declare namespace $ {

	type __shm_hitalama_map_widget_float_table_novirt_1 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_widget_float_table_novirt['cell_content_text'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_widget_float_table_novirt['Table'] >['cell_content_text'] >[0]
	>
	type $shm_hitalama_map_widget_float_table_novirt_grid__records_shm_hitalama_map_widget_float_table_novirt_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_novirt['rows'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_novirt_grid['records'] >
	>
	type $shm_hitalama_map_widget_float_table_novirt_grid__col_ids_shm_hitalama_map_widget_float_table_novirt_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_novirt['col_ids'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_novirt_grid['col_ids'] >
	>
	type $shm_hitalama_map_widget_float_table_novirt_grid__col_head_content_shm_hitalama_map_widget_float_table_novirt_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_novirt['col_head_content'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_novirt_grid['col_head_content'] >
	>
	type $shm_hitalama_map_widget_float_table_novirt_grid__Cell_shm_hitalama_map_widget_float_table_novirt_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_novirt['Cell'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_novirt_grid['Cell'] >
	>
	export class $shm_hitalama_map_widget_float_table_novirt extends $shm_hitalama_map_widget_float_table {
		cell_content_text( id: any): ReturnType< ReturnType< $shm_hitalama_map_widget_float_table_novirt['Table'] >['cell_content_text'] >
		table_row_ids( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_table_novirt['Table'] >['row_ids'] >
		Table( ): $shm_hitalama_map_widget_float_table_novirt_grid
	}
	
	type $shm_hitalama_grid_table__sub_shm_hitalama_map_widget_float_table_novirt_grid_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_novirt_grid['rows'] >
		,
		ReturnType< $shm_hitalama_grid_table['sub'] >
	>
	export class $shm_hitalama_map_widget_float_table_novirt_grid extends $shm_hitalama_map_widget_float_table_grid {
		Table_view( ): $shm_hitalama_grid_table
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=novirt.view.tree.d.ts.map